import React, { Component} from 'react';
import Logo from '../../assets/logo/new_logo_simba.svg'
import menuLogo from '../../assets/menuLogo.png'
import { Nav, NavLink, Bars, NavMenu, Link } from './NavbarElement';
import { Modal, ListGroup, ListGroupItem, Row, Col, Card, CardHeader, DropdownToggle,DropdownMenu,DropdownItem, UncontrolledDropdown, Button} from 'reactstrap';
import { FaBars, FaTimes } from 'react-icons/fa';
import "../../css/nav.css"

export default class DefaultNavbar extends Component{
    constructor(props){
        super(props)
        this.state = {
            modalState : false,
        }
    }
    
    toggle = () => {
        this.setState({modalState : !this.state.modalState})
    }

    render(){
        return(
            <>
                <Nav className="sticky-top">
                    <NavLink to="/home" style={window.innerWidth >= 1000 || window.innerHeight >= 1125 ? {} : {margin:"1em auto auto"}}>
                        <img
                            src={Logo}
                            style={window.innerWidth >= 1000 || window.innerHeight >= 1125 ? {width:250,marginLeft:15} : {width:150,marginTop:"1rem"}}
                        />
                    </NavLink>
                    {window.innerWidth >= 1000 || window.innerHeight >= 1125 
                        ? <Bars onClick={() => this.toggle()} />
                        : <img 
                                src={menuLogo}
                                className="text-primary img-fluid"
                                style={{position:"absolute", top:30, left: 15, width: "30px", height: "15px"}}
                                onClick={() => this.toggle()}
                            />
                    }
                    {
                        window.innerWidth >= 1000 || window.innerHeight >= 1125
                        ? <NavMenu>
                            {/* <NavLink to="/promo" activeStyle>
                                Promo
                            </NavLink> */}
                            <UncontrolledDropdown direction="down">
                                <DropdownToggle className="bg-white border-0" activeStyle>
                                    <NavLink to="/personal" activeStyle>
                                        Personal
                                    </NavLink>
                                </DropdownToggle>
                                <DropdownMenu flip={true} className="dropdown-menu-custom border-0">
                                    <p style={{marginLeft: 30, fontWeight: 600, color: 'black'}}>SuperRoam</p>
                                    {/* <DropdownItem className="fw-bold on-hover">
                                        <NavLink to="/sr2030-my-sim-only-plan" activeStyle>SIMBA SuperRoam 50GB</NavLink>
                                    </DropdownItem>
                                    <DropdownItem className="fw-bold on-hover">
                                        <NavLink to="/simba-super-roam" activeStyle>SIMBA SuperRoam 10GB</NavLink>
                                    </DropdownItem> */}
                                    <DropdownItem className="fw-bold on-hover">
                                        <NavLink to="/sr2030-my-sim-only-plan" activeStyle>50GB</NavLink>
                                    </DropdownItem>
                                    <DropdownItem className="fw-bold on-hover">
                                        <NavLink to="/simba-super-roam" activeStyle>Max</NavLink>
                                    </DropdownItem>
                                    <DropdownItem className="fw-bold on-hover">
                                        <NavLink to="/130gb-my-sim-only-plan" activeStyle>MY</NavLink>
                                    </DropdownItem>
                                    <p style={{marginLeft: 30, fontWeight: 600, color: 'black', marginTop: 10}}>SIM-Only-Plan</p>
                                    <DropdownItem className="fw-bold on-hover">
                                        <NavLink to="/50gb-sim-only-plan" activeStyle>100GB</NavLink>
                                    </DropdownItem>
                                    <DropdownItem className="fw-bold on-hover">
                                        <NavLink to="/80gb-sim-only-plan" activeStyle>130GB</NavLink>
                                    </DropdownItem>
                                    <DropdownItem className="fw-bold on-hover">
                                        <NavLink to="/seniors-sim-only-plan" activeStyle>Seniors</NavLink>
                                    </DropdownItem>
                                    <DropdownItem className="fw-bold on-hover">
                                        <NavLink to="/50gb-prepaid-plan" activeStyle>Prepaid</NavLink>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <NavLink to="/broadband" activeStyle>
                                Broadband
                            </NavLink>
                            <NavLink to="/50gb-business-plan" activeStyle>
                                Business
                            </NavLink>
                            
                            <Link href="https://support.simba.sg/hc/en-us">
                                FAQ
                            </Link>
                            <UncontrolledDropdown direction="down">
                                <DropdownToggle className="bg-white border-0" activeStyle>
                                    {/* <NavLink to="/personal" onClick={() => {return false}} activeStyle>
                                        Personal
                                    </NavLink> */}
                                    <Button 
                                        className='btn-gradient-primary col-12 text-white' 
                                        id='btn-my-account' 
                                        style={{borderRadius:6}} 
                                        onMouseEnter={() => document.getElementById("btn-my-account").click()}
                                    >My Account</Button>
                                </DropdownToggle>
                                <DropdownMenu flip={true} className="dropdown-menu-custom border-0 nav-box"
                                        onMouseLeave={() => document.getElementById("btn-my-account").click()}>
                                    <DropdownItem className="fw-bold on-hover">
                                        <Link href="https://account.simba.sg/">Change of plan</Link>
                                    </DropdownItem>
                                    <DropdownItem className="fw-bold on-hover">
                                        <Link href="https://topup.simba.sg/">Recharge</Link>
                                    </DropdownItem>
                                    <DropdownItem className="fw-bold on-hover">
                                        <Link href="https://novus.tpgtelecom.com.sg/novus-csm/tpgsg/index?_ga=2.214833879.1798301290.1628645729-2080619748.1627535056">Account Balance</Link>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </NavMenu>
                        : <></>
                    }
                </Nav>
                <Modal 
                    isOpen={this.state.modalState} 
                    style={{width:"100%", marginLeft:0}} 
                    toggle={this.toggle}
                >
                    <Card style={{height:1000, marginTop:-8}}>
                        <CardHeader className="bg-white">
                            <Row className='text-center align-middle pb-3'>
                                <Col>
                                {window.innerWidth >= 1000 || window.innerHeight >= 1125 
                                    ? <FaBars
                                        size={24}
                                        className="text-primary"
                                        style={{position:"absolute", top:25}}
                                    />
                                    : <img 
                                    src={menuLogo}
                                    className="text-primary img-fluid"
                                    style={{position:"absolute", top:30, left: 15, width: "30px", height: "15px"}}
                                    onClick={() => this.toggle()}
                                />
                                }
                                </Col>
                                <Col>
                                    <NavLink to="/home" style={{margin:"2em auto auto"}}>
                                        <img
                                            src={Logo}
                                            style={{width:100}}
                                        />
                                    </NavLink>
                                </Col>
                                <Col>
                                    <FaTimes
                                        size={24}
                                        className="text-primary cursor"
                                        style={{position:"absolute", top:25, right:10}}
                                        onClick={() => this.toggle()}
                                    />
                                </Col>
                            </Row>
                        </CardHeader>
                        <ListGroup className="border-0 text-center">
                            <ListGroupItem className="border-0 border-bottom py-4">
                                <NavLink className="text-primary" to="/promo" onClick={() => this.toggle()} activeStyle>
                                    Promo
                                </NavLink>
                            </ListGroupItem>
                            <ListGroupItem className="border-0 border-bottom py-4">
                                <NavLink className="text-primary" to="/personal" onClick={() => this.toggle()} activeStyle>
                                    Personal
                                </NavLink>
                            </ListGroupItem>
                            <ListGroupItem className="border-0 border-bottom py-4">
                                <NavLink className="text-primary" to="/broadband" onClick={() => this.toggle()} activeStyle>
                                    Broadband
                                </NavLink>
                            </ListGroupItem>
                            <ListGroupItem className="border-0 border-bottom py-4">
                                <NavLink className="text-primary" to="/business" onClick={() => this.toggle()} activeStyle>
                                    Business
                                </NavLink>
                            </ListGroupItem>
                            <ListGroupItem className="border-0 border-bottom py-4">
                                <Link className="text-primary fw-bold" href="https://account.simba.sg/">
                                    Change of plan
                                </Link>
                            </ListGroupItem>
                            <ListGroupItem className="border-0 border-bottom py-4">
                                <Link className="text-primary fw-bold" href="https://topup.simba.sg/">
                                    Recharge
                                </Link>
                            </ListGroupItem>
                            <ListGroupItem className="border-0 border-bottom py-4">
                                <Link className="text-primary" href="https://support.simba.sg/hc/en-us">
                                    FAQ
                                </Link>
                            </ListGroupItem>
                            <ListGroupItem className="border-0 border-bottom py-4">
                                <Link className="text-primary" href="https://novus.tpgtelecom.com.sg/novus-csm/tpgsg/index?_ga=2.214833879.1798301290.1628645729-2080619748.1627535056" activeStyle>
                                    My Account
                                </Link>
                            </ListGroupItem>
                        </ListGroup>
                    </Card>
                    
                </Modal>
            </>
        )
    }
}